import { render, staticRenderFns } from "./GameShowConfig.vue?vue&type=template&id=6c6c8dd2&scoped=true"
import script from "./GameShowConfig.vue?vue&type=script&lang=js"
export * from "./GameShowConfig.vue?vue&type=script&lang=js"
import style0 from "./GameShowConfig.vue?vue&type=style&index=0&id=6c6c8dd2&prod&scoped=true&lang=css"
import style1 from "./GameShowConfig.vue?vue&type=style&index=1&id=6c6c8dd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c8dd2",
  null
  
)

export default component.exports